"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _leaflet = require("leaflet");

var _logo_placeholder = _interopRequireDefault(require("../images/logo_placeholder.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RelationModel = function RelationModel(json, lang) {
  var result = [];
  var newBounds = (0, _leaflet.latLngBounds)(); // seemed to work without having to pass init arg

  var relation_types = [];
  json.to_relation.forEach(function (item, index) {
    var object = new Object();
    object.data = new Object();
    object.data.id = item.number;
    object.data.vat = item.vat;
    object.data.zoomed = false;
    object.data.enterprise_name = item.denominations.official_name;
    object.data.establishment_name = item.denominations.name;
    object.data.address = new Object();
    object.data.address.lat = item.address.latitude;
    object.data.address["long"] = item.address.longitude;
    object.data.address.line_1 = "".concat(item.address.streetname, " ").concat(item.address.house_number).concat(item.address.box_number !== '' ? " ".concat(item.address.box_number) : '');
    object.data.address.line_2 = "".concat(item.address.postal_code, " ").concat(item.address.submunicipality ? item.address.submunicipality : item.address.municipality, " ").concat(item.address.municipality ? item.address.submunicipality && item.address.submunicipality !== item.address.municipality ? "(".concat(item.address.municipality, ")") : "" : "");
    object.data.index = index;
    object.data.logos = [];

    function getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';

      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }

      return color;
    }

    if (relation_types.filter(function (e) {
      return e.title === item.from_description;
    }).length === 0) {
      relation_types.push({
        title: item.from_description,
        color: getRandomColor()
      });
    }

    var itemColor = "";
    relation_types.map(function (type) {
      if (type.title === item.from_description) {
        itemColor = type.color;
      }
    });

    if (item.logos.length > 0) {
      item.logos.forEach(function (logo) {
        var logoItem = new Object();
        logoItem.logo = logo.logo;
        logoItem.color = itemColor;
        object.data.logos.push(logoItem);
      });
    } else {
      var logoItem = new Object();
      logoItem.logo = _logo_placeholder["default"];
      logoItem.color = itemColor;
      object.data.logos.push(logoItem);
    }

    result.push(object);
    newBounds.extend([object.data.address.lat, object.data.address["long"]]);
  });
  return {
    result: result,
    newBounds: newBounds,
    relation_types: relation_types
  };
};

var _default = RelationModel;
exports["default"] = _default;